import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import state from './state';
import { SET_NATIVE_INTEGRATION_ACCOUNT_DATA } from './mutations';
import api from '@/api';
import { isNullOrUndefined } from '@/utils/helpers';

const buildNativeIntegrationAccountActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const getNativeIntegrationAccounts = buildNativeIntegrationAccountActionObject('getNativeIntegrationAccounts');
export const getNativeIntegrationAccount = buildNativeIntegrationAccountActionObject('getNativeIntegrationAccount');
export const fetchNativeIntegrationAccount = buildNativeIntegrationAccountActionObject('fetchNativeIntegrationAccount');
export const setNativeIntegrationAccount = buildNativeIntegrationAccountActionObject('setNativeIntegrationAccount');
export const setNativeIntegrationAccounts = buildNativeIntegrationAccountActionObject('setNativeIntegrationAccounts');

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [getNativeIntegrationAccounts.action]({ dispatch }, payload) {
		const { forceGet } = payload;
		const dataIsMissing = Object.values(state.data).length === 0;
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			const ret = await api.getNativeIntegrationAccounts();
			await dispatch(setNativeIntegrationAccounts.action, { data: ret });
		}
	},
	async [getNativeIntegrationAccount.action]({ dispatch }, payload) {
		const { id, forceGet } = payload;
		const dataIsMissing = isNullOrUndefined(state.data[id]);
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			await dispatch(fetchNativeIntegrationAccount.action, { id });
		}
	},
	async [fetchNativeIntegrationAccount.action]({ dispatch }, payload) {
		const { id } = payload;
		const ret = await api.getNativeIntegrationAccount(id);
		await dispatch(setNativeIntegrationAccount.action, { data: ret });
	},
	[setNativeIntegrationAccount.action]({ commit }, payload) {
		const { data: nativeIntegrationAccount } = payload;
		commit(SET_NATIVE_INTEGRATION_ACCOUNT_DATA, { key: nativeIntegrationAccount.id, value: nativeIntegrationAccount });
	},
	async [setNativeIntegrationAccounts.action]({ dispatch }, payload) {
		const { data: nativeIntegrationAccounts } = payload;
		for (const nativeIntegrationAccount of nativeIntegrationAccounts) {
			await dispatch(setNativeIntegrationAccount.action, { data: nativeIntegrationAccount });
		}
	},
};

export default actions;
